import React from "react";
import { useNavigate } from "react-router-dom";

import { BlockTitle, Button } from "../../components/Component";
import VacancyForm from "../../components/vacancyPage/VacancyForm";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import vacancyService from "../../services/vacancyService";
import { useBeManualFetcher } from "../../hooks/useBeManualFetcher";
import {
  createEmptyVacancy,
  buildVacancyRequestBody,
} from "../../utilities/vacancyUtils";

const VacancyCreatePage = () => {
  const navigate = useNavigate();
  const [onFetch, isLoading] = useBeManualFetcher();

  const handleSubmit = async (form) =>
    await onFetch({
      action: () => vacancyService.createVacancy(buildVacancyRequestBody(form)),
      onLoad: () => navigate("/vacancies", { replace: true }),
      successMessage: "Vacancy created successfully",
    });

  return (
    <React.Fragment>
      <Head title={"Create Vacancy"}></Head>
      <Content>
        <Button
          color="white border-light"
          className="mb-2"
          onClick={() => navigate("/vacancies")}
          iconName="arrow-left"
          title={"Back"}
        />
        <BlockTitle tag="h4" className="mb-4">
          Create Vacancy
        </BlockTitle>

        <VacancyForm
          initialValues={createEmptyVacancy()}
          onSubmit={handleSubmit}
          onCancel={() => navigate("/vacancies")}
          isLoading={isLoading}
        />
      </Content>
    </React.Fragment>
  );
};

export default VacancyCreatePage;
